// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiped-events';
import PinchZoom from 'pinch-zoom-js';
import { get360url } from './utils-module.js';

const blockElem = initBlockElem();
const bodyPage = initBodyPage();
const itemsElems = initItemsElems();

const block = '.full-screen-view';
const active = `${block}_show`;
const list = `${block}__list`;
const item = `${block}__item`;
const content = `${block}__content`;
const contentType360 = `${block}__content_type_360`;
const watermark = `${block}__watermark`;
const getItemByIndex = (index) => `${item}[data-index="${index}"]`;
const getVideoByIndex = (index) => `${getItemByIndex(index)} video${content}`;
const currentItem = `${block}__item_current`;
const closeBtn = '.close-full-screen-view';
const docBody = '.body';
const holdDocBody = '.body_hold';
const prev = `${block}__nav-btn-prev`;
const next = `${block}__nav-btn-next`;
const disabledBtnClassName = `${block}__button_disabled`;
const shareBtn = `${block}__button_share`;
const downloadBtn = `${block}__button_download`;
const shareBtnText = `${shareBtn} ${block}__btn-text`;
const downloadBtnText = `${downloadBtn} ${block}__btn-text`;
const playBtn = `${block}__video-btn_play`;
const pauseBtn = `${block}__video-btn_pause`;
const displayOffVideoBtn = `${block}__video-btn_display-off`;
const hiddenBtnClassName = `${block}__video-btn_hidden`;
const getPlayBtnByIndex = (index) => `${getItemByIndex(index)} ${playBtn}`;
const getPauseBtnByIndex = (index) => `${getItemByIndex(index)} ${pauseBtn}`;

function getClassName(cssPath) {
  return cssPath.slice(1);
}

function showPrevItem() {
  const currentIndex = itemsElems.currentIndex();
  const prevIndex = currentIndex - 1;
  const index = prevIndex < 0 ? itemsElems.maxIndex() : prevIndex;
  // console.log('showPrevItem', prevIndex, getMaxIndex(), index);
  itemsElems.goFromItemToItem({ currentIndex, nextIndex: index });
}

function showNextItem() {
  const currentIndex = itemsElems.currentIndex();
  const nextIndex = currentIndex + 1;
  const index = nextIndex > itemsElems.maxIndex() ? 0 : nextIndex;
  // console.log('showNextItem', nextIndex, getMaxIndex(), index);
  itemsElems.goFromItemToItem({ currentIndex, nextIndex: index });
}

export function showItems(items, showIndex = 0) {
  // console.log('showItems', items, showIndex);

  itemsElems.render(items);

  itemsElems.goFromItemToItem({ nextIndex: showIndex });

  blockElem.display();

  bodyPage.freeze();

  blockElem.onceClose(hideItems);
  blockElem.onNextItem(showNextItem);
  blockElem.onPrevItem(showPrevItem);
}

export function hideItems() {
  blockElem.displayOff();
  bodyPage.unfreeze();

  itemsElems.clearRender();

  blockElem.offNextItem(showNextItem);
  blockElem.offPrevItem(showPrevItem);
}

export function onShareBtn(cb) {
  const $btn = document.querySelector(shareBtn);
  $btn.addEventListener('click', () => {
    const currentIndex = itemsElems.currentIndex();
    const $item = document.querySelector(getItemByIndex(currentIndex));
    cb({ id: Number($item.dataset.id) });
  });
}

export function onDownloadBtn(cb) {
  const $btn = document.querySelector(downloadBtn);
  $btn.addEventListener('click', () => {
    const currentIndex = itemsElems.currentIndex();
    const $item = document.querySelector(getItemByIndex(currentIndex));
    cb({ id: Number($item.dataset.id) });
  });
}

function initBlockElem() {
  return {
    display,
    displayOff,
    onNextItem,
    onPrevItem,
    offNextItem,
    offPrevItem,
    onceClose,
  };

  function display() {
    const $block = document.querySelector(block);
    $block.classList.add(getClassName(active));
  }

  function displayOff() {
    const $block = document.querySelector(block);
    $block.classList.remove(getClassName(active));
  }

  function onNextItem(cb) {
    onSwipedLeft(cb);
    onClickNextBtn(cb);
  }

  function onPrevItem(cb) {
    onSwipedRight(cb);
    onClickPrevBtn(cb);
  }

  function offNextItem(cb) {
    offSwipedLeft(cb);
    offClickNextBtn(cb);
  }

  function offPrevItem(cb) {
    offSwipedRight(cb);
    offClickPrevBtn(cb);
  }

  function onceClose(cb) {
    const $btn = document.querySelector(closeBtn);
    $btn.addEventListener('click', cb, { once: true });
  }

  function onSwipedLeft(cb) {
    const $block = document.querySelector(block);
    $block.addEventListener('swiped-left', cb);
  }

  function onSwipedRight(cb) {
    const $block = document.querySelector(block);
    $block.addEventListener('swiped-right', cb);
  }

  function offSwipedLeft(cb) {
    const $block = document.querySelector(block);
    $block.removeEventListener('swiped-left', cb);
  }

  function offSwipedRight(cb) {
    const $block = document.querySelector(block);
    $block.removeEventListener('swiped-right', cb);
  }

  function onClickNextBtn(cb) {
    const $btn = document.querySelector(next);
    $btn.addEventListener('click', cb);
  }

  function onClickPrevBtn(cb) {
    const $btn = document.querySelector(prev);
    $btn.addEventListener('click', cb);
  }

  function offClickNextBtn(cb) {
    const $btn = document.querySelector(next);
    $btn.removeEventListener('click', cb);
  }

  function offClickPrevBtn(cb) {
    const $btn = document.querySelector(prev);
    $btn.removeEventListener('click', cb);
  }
}

function initItemsElems() {
  const pinchZoomManager = initPinchZoomManager();
  const videoEventsSubscribers = {};

  return {
    render,
    clearRender,
    currentIndex: getCurrentIndex,
    maxIndex: getMaxIndex,
    goFromItemToItem,
  };

  function render(items) {
    const $list = document.querySelector(list);
    const itemsHTML = items
      .map(({ id, type, src, watermarkSrc, canShare, canDownload }, index) =>
        prepareItem({ index, id, type, src, watermarkSrc, canShare, canDownload })
      )
      .join(' ');
    $list.innerHTML = itemsHTML;
    $list.dataset.length = items.length;
  }

  function clearRender() {
    pinchZoomManager.clearAll();

    const $list = document.querySelector(list);
    $list.innerHTML = '';
    $list.dataset.length = 0;
  }

  function prepareItem({ index, id, type, src, watermarkSrc, canShare, canDownload }) {
    return `
     <div 
       class="${getClassName(item)}" 
       data-id="${id}" 
       data-type="${getTypeContent()}" 
       data-index="${index}" 
       data-can-download="${canDownload}" 
       data-can-share="${canShare}"
    >
     ${renderWatermark(watermarkSrc)}${contentElem()}
    </div>
    `;

    function contentElem() {
      if (type === '360') {
        return `
          <iframe class="${getClassName(content)} ${getClassName(contentType360)}" src="${get360url(
          src
        )}" frameborder="0" allowfullscreen></iframe>
        `;
      }
      if (isVideo()) {
        return `
          <video class="${getClassName(content)}" playsinline>
            <source src="${src}" type="video/mp4">
            Your browser does not support the video tag.
          </video>
          <div class="${getClassName(playBtn)} ${getClassName(displayOffVideoBtn)}"></div>
          <div class="${getClassName(pauseBtn)} ${getClassName(displayOffVideoBtn)}"></div>
        `;
      }
      return `<img class="${getClassName(content)}" src="${src}" alt="" />`;
    }

    function renderWatermark(imgSrc) {
      if (imgSrc) {
        return `<div class="${getClassName(watermark)}" style="background-image:url('${imgSrc}')"></div>`;
      }
      return '';
    }

    function getTypeContent() {
      if (isVideo()) return 'video';
      return 'photo';
    }

    function isVideo() {
      return src.split('.').pop().toLowerCase() === 'mp4';
    }
  }

  function getCurrentIndex() {
    const $currentItem = document.querySelector(currentItem);
    if (!$currentItem) return 0;
    return Number($currentItem.dataset.index);
  }

  function getMaxIndex() {
    const $list = document.querySelector(list);
    return Number($list.dataset.length) - 1;
  }

  function goFromItemToItem({ currentIndex = -1, nextIndex }) {
    if (currentIndex > -1) {
      pinchZoomManager.resetZoom(currentIndex);
      if (isItemVideo(currentIndex)) pauseVideo(currentIndex);
      unsetAsCurrent(currentIndex);
      setTimeout(() => {
        unsubscribeOnVideoEvents(currentIndex);
      }, 0);
    }

    subscribeOnVideoEvents(nextIndex, { onPlay: onPlayVideo, onPause: onPauseVideo, onEnded: onVideoEnded });
    if (isItemVideo(nextIndex)) playVideo(nextIndex, 0);
    setAsCurrent(nextIndex);
    if (isItemPhoto(nextIndex)) pinchZoomManager.setUp(nextIndex);
    showBtn('share', isAvailableToShare(nextIndex));
    showBtn('download', isAvailableDownload(nextIndex));
  }

  function subscribeOnVideoEvents(index, { onPlay, onPause, onEnded }) {
    const $video = document.querySelector(getVideoByIndex(index));
    const $playBtn = document.querySelector(getPlayBtnByIndex(index));
    const $pauseBtn = document.querySelector(getPauseBtnByIndex(index));
    if (!$video) return;
    videoEventsSubscribers[index] = {
      onPlay: () => onPlay(index),
      onPause: () => onPause(index),
      onEnded: () => onEnded(index),
      play: () => playVideo(index),
      pause: () => pauseVideo(index),
    };
    $video.addEventListener('play', videoEventsSubscribers[index].onPlay);
    $video.addEventListener('pause', videoEventsSubscribers[index].onPause);
    $video.addEventListener('ended', videoEventsSubscribers[index].onEnded);
    $playBtn.addEventListener('click', videoEventsSubscribers[index].play);
    $pauseBtn.addEventListener('click', videoEventsSubscribers[index].pause);
  }

  function unsubscribeOnVideoEvents(index) {
    const $video = document.querySelector(getVideoByIndex(index));
    const $playBtn = document.querySelector(getPlayBtnByIndex(index));
    const $pauseBtn = document.querySelector(getPauseBtnByIndex(index));
    if (!$video || !videoEventsSubscribers[index]) return;
    $video.removeEventListener('play', videoEventsSubscribers[index].onPlay);
    $video.removeEventListener('pause', videoEventsSubscribers[index].onPause);
    $video.removeEventListener('ended', videoEventsSubscribers[index].onEnded);
    $playBtn.removeEventListener('click', videoEventsSubscribers[index].play);
    $pauseBtn.removeEventListener('click', videoEventsSubscribers[index].pause);
    delete videoEventsSubscribers[index];
  }

  function onPlayVideo(index, { hideBtnTimeout = 2000 } = {}) {
    const $playBtn = document.querySelector(getPlayBtnByIndex(index));
    const $pauseBtn = document.querySelector(getPauseBtnByIndex(index));
    if (!$playBtn || !$pauseBtn) return;
    $playBtn.classList.add(getClassName(displayOffVideoBtn));
    $pauseBtn.classList.remove(getClassName(displayOffVideoBtn));
    setTimeout(() => {
      if ($pauseBtn.classList.contains(getClassName(displayOffVideoBtn))) return;
      $pauseBtn.classList.add(getClassName(hiddenBtnClassName));
    }, hideBtnTimeout);
  }

  function onPauseVideo(index) {
    const $playBtn = document.querySelector(getPlayBtnByIndex(index));
    const $pauseBtn = document.querySelector(getPauseBtnByIndex(index));
    if (!$playBtn || !$pauseBtn) return;
    $playBtn.classList.remove(getClassName(displayOffVideoBtn));
    $pauseBtn.classList.add(getClassName(displayOffVideoBtn));
    $pauseBtn.classList.remove(getClassName(hiddenBtnClassName));
  }

  function onVideoEnded(index) {
    const $video = document.querySelector(getVideoByIndex(index));
    const $playBtn = document.querySelector(getPlayBtnByIndex(index));
    const $pauseBtn = document.querySelector(getPauseBtnByIndex(index));
    $video.currentTime = 0;
    if (!$playBtn || !$pauseBtn) return;
    $playBtn.classList.remove(getClassName(displayOffVideoBtn));
    $pauseBtn.classList.add(getClassName(displayOffVideoBtn));
    $pauseBtn.classList.remove(getClassName(hiddenBtnClassName));
  }

  function isAvailableToShare(index) {
    const $item = document.querySelector(getItemByIndex(index));
    if (!$item) return false;
    return $item.dataset.canShare === 'true';
  }

  function isAvailableDownload(index) {
    const $item = document.querySelector(getItemByIndex(index));
    if (!$item) return false;
    return $item.dataset.canDownload === 'true';
  }

  function isItemVideo(index) {
    return isItem('video', index);
  }

  function isItemPhoto(index) {
    return isItem('photo', index);
  }

  function isItem(type, index) {
    const $item = document.querySelector(getItemByIndex(index));
    if (!$item) return false;
    return $item.dataset.type === type;
  }

  function setAsCurrent(index) {
    const $elem = document.querySelector(getItemByIndex(index));
    if (!$elem) return;
    $elem.classList.add(getClassName(currentItem));
  }

  function unsetAsCurrent(index) {
    const $elem = document.querySelector(getItemByIndex(index));
    if (!$elem) return;
    $elem.classList.remove(getClassName(currentItem));
  }

  function playVideo(index, startTime = null) {
    const $video = document.querySelector(getVideoByIndex(index));
    if (!$video) return;
    if (startTime !== null) $video.currentTime = startTime;
    $video.play().catch(() => {
      /* Ignore interrupt play video */
    });
  }

  function pauseVideo(index) {
    const $video = document.querySelector(getVideoByIndex(index));
    if (!$video) return;
    $video.pause();
  }

  function showBtn(name, bool) {
    const $btn = document.querySelector(getBtnClass(name));
    if (bool) {
      $btn.classList.remove(getClassName(disabledBtnClassName));
    } else {
      $btn.classList.add(getClassName(disabledBtnClassName));
    }
  }

  function getBtnClass(name) {
    if (name === 'share') return shareBtn;
    if (name === 'download') return downloadBtn;
    return null;
  }

  function getBtnTextClass(name) {
    if (name === 'share') return shareBtnText;
    if (name === 'download') return downloadBtnText;
    return null;
  }
}

function initPinchZoomManager() {
  let cachePinchZoom = {};

  return {
    setUp: (index) => {
      if (!cachePinchZoom[index]) {
        cachePinchZoom[index] = new PinchZoom(document.querySelector(getItemByIndex(index)).querySelector(content), {
          draggableUnzoomed: false,
        });
      }
    },
    resetZoom: (index) => {
      if (cachePinchZoom[index]) {
        cachePinchZoom[index].zoomOutAnimation();
      }
    },
    clearAll: () => {
      Object.values(cachePinchZoom).forEach((pz) => pz.destroy());
      cachePinchZoom = {};
    },
  };
}

function initBodyPage() {
  return {
    freeze,
    unfreeze,
  };

  function freeze() {
    const $body = document.querySelector(docBody);
    $body.classList.add(getClassName(holdDocBody));
  }

  function unfreeze() {
    const $body = document.querySelector(docBody);
    $body.classList.remove(getClassName(holdDocBody));
  }
}
